document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".mySwiper", {
      loop: true,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      effect: "fade",
      fadeEffect: { crossFade: true },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });

    const toggleBtn = document.getElementById("swiper-toggle");
    if (toggleBtn) {
      toggleBtn.addEventListener("click", () => {
        if (toggleBtn.classList.contains("fa-pause")) {
          swiper.autoplay.stop();
          toggleBtn.classList.remove("fa-pause");
          toggleBtn.classList.add("fa-play");
        } else {
          swiper.autoplay.stop();
          toggleBtn.classList.remove("fa-play");
          toggleBtn.classList.add("fa-pause");
        }
      });
    }
  });